export default "__VITE_ASSET__CIymHz6k__"